<template>
  <!-- 5-1 医疗机构信息查看 -->
  <div class="main-box">
    <div class="main-box-all-css">
      <!-- 主要内容部分 -->
      <div class="main-box-css">
        <!-- 左边表单部分 -->
        <div class="left-box">
          <!-- 第一行 -->
          <div class="one-line">
            <div class="avatar">
              <img :src="avatarUrl" alt="" />
            </div>
            <div class="institution-name">
              <div class="institution-box">
                <div class="institution-title">{{ $t("certified") }}</div>
                <span>{{ $t("institutionName") }}</span>
                <p class="institution-main">{{ institutionName }}</p>
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("postCode") }}</span>
              <p class="small-box-title">{{ postCode }}</p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("location") }}</span>
              <p class="small-box-title">{{ area }}</p>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("institutionalAttributes") }}</span>
              <p class="small-box-title">
                {{
                  this.language === "CN"
                    ? infoData.attributes_dictText
                    : infoData.jpattributes_dictText
                }}
              </p>
            </div>
            <div class="big-input-box">
              <span>HP or SNS</span>
              <p class="small-box-title">{{ hPorSNS }}</p>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("representativeName") }}</span>
              <p class="small-box-title">{{ representativeName }}</p>
            </div>
            <div class="big-input-box">
              <span>{{ $t("institutionalNumber") }}</span>
              <p class="small-box-title">{{ phoneNumber }}</p>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="two-line">
            <div class="small-input-box">
              <span>{{ $t("registeredCapital") }}</span>
              <p class="small-box-title">
                {{
                  this.language === "CN"
                    ? infoData.capitalAmount_dictText
                    : infoData.jpcapitalAmount_dictText
                }}
                <!-- {{ capital }} -->
              </p>
            </div>
            <div class="small-dropdown">
              <span>{{ $t("numberOfEmployees") }}</span>
              <p class="small-box-title">
                <!-- {{ numberEmployees }} -->
                {{
                  this.language === "CN"
                    ? infoData.employeeNumber_dictText
                    : infoData.jpemployeeNumber_dictText
                }}
              </p>
            </div>
            <div class="small-dropdown">
              <span>{{ $t("numberOfBets") }}</span>
              <p class="small-box-title">
                <!-- {{ numberBets }} -->
                {{
                  this.language === "CN"
                    ? infoData.bedNumber_dictText
                    : infoData.jpbedNumber_dictText
                }}
              </p>
            </div>
          </div>
          <!-- 第六行 -->
          <div class="textarea-line">
            <div class="textarea-line-box">
              <span>{{ $t("businessContent") }}</span>
              <p class="textarea-css-main">{{ textData }}</p>
            </div>
          </div>
        </div>
        <!-- 右边表格部分 -->
        <div class="right-box">
          <el-table
            :data="tableData"
            style="width: 100%"
            height="560px"
            @sort-change="changeTableSort"
            @row-click="rowClick"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="jobName"
              label="案件名"
              min-width="120"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <p>{{ $t("caseName") }}</p>
                <el-input
                  v-model="tableSearch1"
                  @input="searchFn"
                  size="mini"
                  placeholder="Search"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="workSpace"
              label="勤務地"
              width="100"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <p>{{ $t("workLocation") }}</p>
                <el-input
                  v-model="tableSearch2"
                  @input="searchFn"
                  size="mini"
                  placeholder="Search"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="掲載日"
              width="110"
              :show-overflow-tooltip="true"
            >
              <template slot="header" slot-scope="scope">
                <p>{{ $t("payonTheDay") }}</p>
                <el-input
                  v-model="tableSearch3"
                  @input="searchFn"
                  size="mini"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.createTime.split(" ")[0] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="visitedTime"
              label="観覧回数"
              :sortable="'custom'"
            >
              <template slot="header">
                <p class="empty-ps">{{ $t("numberOfVisits") }}</p>

                <p class="empty"></p>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页部分 -->
          <div class="pagination-table">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="tableSize"
              layout=" prev, pager, next"
              :total="total"
            >
            </el-pagination>
            <span class="per-page">Rows per page</span>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ tableSize }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">5</el-dropdown-item>
                <el-dropdown-item command="b">10</el-dropdown-item>
                <el-dropdown-item command="c">15</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="main-button-box">
        <button @click="toEdit">{{ $t("toEdit") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUrlFromOSS,
  medicalInstitutionDetailsQuery,
  fuzzyJobByMedicalId,
  queryBasicInfo
} from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "medicalInstitutionInformation",
  components: {},
  data() {
    return {
      institutionName: "", //機関名
      postCode: "", //郵便番号
      ll: "",
      area: "", //所在地
      agencyAttribute: "", //機関属性
      hPorSNS: "", //HP or SNS
      representativeName: "", //代表者氏名
      phoneNumber: "", //機関の電話番号
      numberEmployees: "", //授業員数
      numberBets: "", //ベット数
      capital: "", //資本金
      textData: "", //事业内容
      tableSearch1: "", //table案件名
      tableSearch2: "", //table勤務地
      tableSearch3: "", //table掲載日
      medicalId: "",
      avatarUrl: "", //头像回显
      tableData: [], //table数据内容
      tableSize: 5,
      currentPage: 1,
      total: 50,
      language: "",
      infoData: {}
    };
  },

  created() {
    this.language = window.localStorage.getItem("language");

    console.log(this.language);
    this.getList();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
      }
    },
    // 搜索
    searchFn() {
      var fakeInfo2 = {
        medicalId: this.medicalId,
        pageNumber: this.currentPage,
        pageSize: this.tableSize,
        jobName: this.tableSearch1,
        workSpace: this.tableSearch2,
        createTime: this.tableSearch3
      };
      fuzzyJobByMedicalId(fakeInfo2)
        .then(res2 => {
          console.log("--------右侧列表数据获取--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data));
            console.log("输出", aesFecInfo2);
            // this.totalItem = aesFecInfo2.total2;
            this.total = aesFecInfo2.total2;
            this.tableData = aesFecInfo2.data2;
            console.log(this.tableData, "4tableData");
            console.log("获取成功");
          } else {
            this.$message.error("获取数据失败");
          }
        })
        .catch(res => {});
    },
    //接口 获取表格数据
    getList() {
      queryBasicInfo()
        .then(res => {
          console.log("select");
          console.log(res);
          if (res.data.code === "A0000") {
            let aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            aesFecInfo = aesFecInfo.data[0];
            console.log(aesFecInfo, "851665");
            this.infoData = aesFecInfo;
            this.institutionName = aesFecInfo.medicalName; //機関名
            this.postCode = aesFecInfo.postNumber; //郵便番号
            this.area = aesFecInfo.address; //所在地
            this.agencyAttribute = aesFecInfo.attributes; //機関属性
            this.hPorSNS = aesFecInfo.hpOrSns; //HP or SNS
            this.representativeName = aesFecInfo.legalPerson; //代表者氏名
            this.phoneNumber = aesFecInfo.telephone; //機関の電話番号
            this.capital = aesFecInfo.capitalAmount; //資本金
            this.frequency = aesFecInfo.employeeNumber; //職員数
            this.numberBets = aesFecInfo.bedNumber; //ベット数
            this.textData = aesFecInfo.introduction; //事業内容
            this.numberEmployees = aesFecInfo.employeeNumber; //
            this.medicalId = aesFecInfo.medicalId;
            this.getlist1();
            let avatarAddressUrl = aesFecInfo.avatarAddress;
            this.getUrl(avatarAddressUrl);
          }
        })
        .catch(res => {});
    },
    //图片回显
    getUrl(url) {
      var fakeInfo = {
        message: url
      };
      console.log(fakeInfo);
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo, "aesFecInfo");
            if (
              aesFecInfo.message ===
              "https://test202257.oss-cn-shanghai.aliyuncs.com/"
            ) {
              this.avatarUrl = require("../../assets/avatar.png");
              return;
            }
            this.avatarUrl = aesFecInfo.message;
          }
        })
        .catch(() => {});
    },
    getlist1() {
      //右侧数据获取
      console.log("--------右侧列表数据获取--------", this.medicalId);
      var fakeInfo2 = {
        medicalId: this.medicalId,
        pageNumber: this.currentPage,
        pageSize: this.tableSize
      };
      medicalInstitutionDetailsQuery(fakeInfo2)
        .then(res2 => {
          console.log("--------右侧列表数据获取--------");
          console.log(res2);
          if (res2.data.code === "A0000") {
            const aesFecInfo2 = JSON.parse(AES.decrypt(res2.data.data));
            console.log("输出", aesFecInfo2);
            // this.totalItem = aesFecInfo2.total2;
            this.total = aesFecInfo2.total2;
            this.tableData = aesFecInfo2.data2;
            console.log(this.tableData, "4tableData");
            console.log("获取成功");
          } else {
            this.$message.error("获取数据失败");
          }
        })
        .catch(res => {});
    },
    //排序
    changeTableSort(custom) {
      console.log(custom.order, "555");
      if (custom.order === "ascending") {
        this.tableData = this.tableData.sort((a, b) => a["d"] - b["d"]);
      } else {
        this.tableData = this.tableData.sort((a, b) => b["d"] - a["d"]);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getlist1();
    },
    //分页条数
    handleCommand(command) {
      if (command === "a") {
        this.tableSize = 5;
      } else if (command === "b") {
        this.tableSize = 10;
      } else {
        this.tableSize = 15;
      }
      this.currentPage = 1;
      this.getlist1();
    },
    // 编辑跳转页面
    toEdit() {
      this.$router.push({
        path: "/medicalCertificationModification"
      });
    },
    //行点击
    rowClick(row) {
      console.log(row);
      console.log("行点击事件");
      this.$router.push({
        path: "/medicalInstitutionCaseRecruitmentList",
        query: {
          jobId: row.jobId
        }
      });
    }
  }
};
</script>
<style scoped>
.main-box {
  width: 95%;
  height: 100%;
  background: #fff;
  margin-bottom: 60px;
}
.main-box-all-css {
  width: 100%;
  margin: 0 auto;
}
.main-box-css {
  display: flex;
  height: 620px;
  padding: 30px 0 0 0;
}
.left-box {
  width: 49%;
  margin-left: 2%;
  height: 100%;
}
.one-line {
  height: 160px;
  display: flex;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
.avatar img {
  width: 150px;
  height: 150px;
}
.institution-name {
  height: 150px;
  flex: 1;
}
.institution-box {
  width: 300px;
  height: 57px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: 35px;
  position: relative;
  margin-top: 70px;
  float: left;
}
.institution-title {
  background: #fc630c;
  border-radius: 4px;
  height: 16px;
  width: 49px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: -22px;
  right: 0;
}
.institution-box span {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  background: #ffffff;
}
.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.two-line {
  height: 50px;
  margin-top: 15px;
  display: flex;
}
.small-input-box {
  width: 220px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.small-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
}
.big-input-box {
  width: 270px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.big-input-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.big-input-box /deep/ .el-input {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.big-input-box /deep/ .el-input__inner {
  height: 38px;
  border: 1px solid transparent;
  box-sizing: border-box;
}
.inline-box-dropdown {
  height: 38px;
  width: 180px;
  margin-top: 2px;
  margin-left: 10px;
}
.inline-box-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 180px;
}
.inline-box-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 170px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.inline-box-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.small-dropdown {
  width: 130px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-left: 10px;
}
.small-dropdown span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.small-dropdown /deep/ .el-dropdown {
  height: 38px;
  width: 110px;
}
.small-dropdown /deep/ .el-dropdown-link {
  height: 38px;
  line-height: 38px;
  width: 110px;
  position: static;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
}
.small-dropdown /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 38px;
}
.inline-box-dropdown1 {
  height: 38px;
  width: 110px;
  margin-top: 2px;
  margin-left: 10px;
}
.textarea-line {
  margin-top: 15px;
  width: 500px;
  height: 180px;
}
.textarea-line-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-line-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.right-box {
  width: 50%;
  height: 100%;
  margin-left: 4%;
  padding-top: 70px;
  box-sizing: border-box;
}
.right-box /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}
.right-box .empty {
  height: 30px;
}
.right-box /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: -5px;
}
.empty-ps {
  position: relative;
}
.pagination-table {
  display: flex;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.25px;
  color: #454d59;
  margin-top: 10px;
  align-items: center;
  justify-content: right;
}
.pagination-table /deep/ .el-dropdown {
  background: #ffffff;
  width: 60px;
  line-height: 24px;
  height: 24px;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  margin-left: 10px;
}
.pagination-table /deep/ .el-dropdown-link {
  width: 60px;
  height: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  display: inline-block;
}
.pagination-table /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 24px;
  margin-right: 5px;
}
.pagination {
  margin-top: 10px;
}
.per-page {
  margin-left: 20px;
}
.main-button-box {
  text-align: center;
  width: 500px;
  margin-top: 20px;
}
.main-button-box button {
  width: 152px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionInformation/index.vue